module.exports = __webpack_public_path__ + "static/media/rebirth_6.3bd529d3.jpg";